export const environment = {
  production: true,
  api: 'https://api.ihunter.io',
  urlApi: 'https://api.ihunter.io/api/',
  urlApiTercerizacionNest: 'https://devapitercerizacion.ihunter.io/api/',

  mifielENV: 'www',
  
  urlCreaFactura:'https://api.facturama.mx/2/cfdis',
  urlConsultarFacturaPDf:'https://api.facturama.mx/Cfdi/pdf/issued',
  urlConsultarFacturaXml:'https://api.facturama.mx/Cfdi/xml/issued',
  urlEnviarFactura:'https://api.facturama.mx/Cfdi?cfdiType=issued&cfdiId=',
  tokenFacturama: 'YXJkaXRpaW50ZXJuYXRpb25hbDpjcm8yNDA1',
  urlReportFunction: 'https://us-central1-ihunter-dev.cloudfunctions.net/app/api/',
  expeditionPlace:"66265",  
  firebase: {
   // DEV DATABASE 
   /*
   apiKey: 'AIzaSyACRr-SKiZH-miqih8v8rvraMIXRzAK9Io',
   authDomain: 'ihunter-dev.firebaseapp.com',
   databaseURL: 'https://ihunter-io.firebaseio.com',
   projectId: 'ihunter-dev',
   storageBucket: 'ihunter-dev.appspot.com',
   messagingSenderId: '881288455257',
   appId: '1:881288455257:web:67d96496b6de62c43cbd48',
   measurementId: 'G-NF55C96X80',*/


   // PROD DATABASE 
   apiKey: "AIzaSyBSYPyon2PwOCiu9JY6x9YLG00bkeSIek8",
   authDomain: "ihunter--io.firebaseapp.com",
   databaseURL: "https://ihunter--io.firebaseio.com",
   projectId: "ihunter--io",
   storageBucket: "ihunter--io.appspot.com",
   messagingSenderId: "848819043185",
   appId: "1:848819043185:web:899fbed0517f4c3213d4d0",
   measurementId: "G-TB3N8F652J"
  },
};